"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {hasClass, removeClass, addClass, on, closest, findAll, findIn, getAttribute} from "@elements/dom-utils";

export function init() {
    onFind('.js-copy-to-clipboard', function (copyBtn) {
        on('click', function (evt) {
            let btn = evt.target;
            let icon = findIn('.js-copy-to-clipboard__icon', btn);
            let html = btn.getAttribute('data-copy-to-clipboard-html') || false;
            if(html) {
                copyToClipboard(html, btn, icon);
            }
        }, copyBtn);
    });
}


function copyToClipboard(html, btn, icon) {
    let container = document.createElement('div');
    container.innerHTML = html;

    // Hide element
    container.style.position = 'fixed';
    container.style.pointerEvents = 'none';
    container.style.opacity = 0;

    document.body.appendChild(container);

    // Copy to clipboard
    window.getSelection().removeAllRanges();
    let range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);

    document.execCommand('copy');
    document.body.removeChild(container);
    
    addClass('success', icon);

    setTimeout(function(){
        removeClass('success', icon);
    }, 3000)
}


